import { FormInput, FormItem, FormLabel, IconFa } from '@/components/wm';
import { zodResolver } from '@hookform/resolvers/zod';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export function ConfirmDelete({ data, onChangeField, onCompleted }) {
    const formSchema = z.object({
        confirmation: z.string().refine(val => val === 'DELETE', {
            message: i18next.t('alarms.bulk_delete_confirmation', "Type 'DELETE' to confirm")
        })
    });

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            confirmation: ''
        },
        mode: 'onChange'
    });

    useEffect(() => {
        onCompleted(form.formState.isValid);
    }, [form.formState.isValid, onCompleted]);

    return (
        <div className="tw-w-full tw-max-w-md tw-mx-auto tw-py-8">
            <div className="tw-bg-destructive/10 tw-border tw-border-destructive/20 tw-rounded-xl tw-p-6 tw-mb-8 tw-text-center">
                <div className="tw-flex tw-justify-center tw-mb-4">
                    <IconFa color="destructive" icon="exclamation" size="large"/>
                </div>
                <h3 className="tw-text-lg tw-font-bold tw-text-destructive tw-mb-2">
                    {i18next.t('ui.danger', 'Danger!')}
                </h3>
                <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed">
                    {i18next.t('alarms.bulk_delete_warning', 'This will delete all selected alarms. This action is irreversible and final. Proceed with caution.')}
                </p>
                <div className="tw-mt-2 tw-text-xs tw-text-destructive/80 tw-font-medium">
                    {i18next.t('alarms.selected_count', '{{count}} alarms selected', { count: data.ids?.length || 0 })}
                </div>
            </div>

            <div className="tw-max-w-xs tw-mx-auto">
                <FormItem>
                    <FormLabel className="tw-text-center tw-block tw-mb-4 tw-ml-0">
                        {i18next.t('alarms.bulk_delete_confirmation_label', 'To confirm deletion, please type DELETE in the box below')}
                    </FormLabel>
                    <FormInput
                        {...form.register('confirmation')}
                        autoComplete="off"
                        className="tw-text-center tw-h-12 tw-text-lg"
                        placeholder={i18next.t('alarms.bulk_delete_confirmation', 'Type DELETE to confirm')}
                    />
                </FormItem>
            </div>
        </div>
    );
}
